module.exports = __webpack_public_path__ + "static/media/3pic.4ce47ee8.png";